import { collection, getDocs, limit, orderBy, query, where } from 'firebase/firestore';
import { db } from '../firebase';
import { PublishedFamilyTreeRecord } from '../types/familyTree';
import { SurveillancePlanRecord, SurveillanceReviewPrompt } from '../types/surveillance';

export interface MemberSurveillanceOverview {
  latestPlan: SurveillancePlanRecord | null;
  openPrompts: SurveillanceReviewPrompt[];
  familyTree: PublishedFamilyTreeRecord | null;
}

export async function getMemberSurveillanceOverview(userId: string): Promise<MemberSurveillanceOverview> {
  const [plansSnap, promptsSnap, familyTreeSnap] = await Promise.all([
    getDocs(
      query(
        collection(db, 'surveillance_plans'),
        where('userId', '==', userId),
        where('status', '==', 'released'),
      ),
    ),
    getDocs(
      query(
        collection(db, 'surveillance_review_prompts'),
        where('userId', '==', userId),
        where('status', '==', 'open'),
        orderBy('createdAt', 'desc'),
      ),
    ),
    getDocs(query(collection(db, 'family_trees'), where('userId', '==', userId), where('status', '==', 'published'), limit(1))),
  ]);

  const latestPlanDoc = [...plansSnap.docs].sort((left, right) => {
    const leftUpdated = left.data().updatedAt?.toMillis?.() || 0;
    const rightUpdated = right.data().updatedAt?.toMillis?.() || 0;
    return rightUpdated - leftUpdated;
  })[0];
  const familyTreeDoc = familyTreeSnap.docs[0];

  return {
    latestPlan: latestPlanDoc ? ({ id: latestPlanDoc.id, ...latestPlanDoc.data() } as SurveillancePlanRecord) : null,
    openPrompts: promptsSnap.docs.map((snapshot) => ({ id: snapshot.id, ...snapshot.data() })) as SurveillanceReviewPrompt[],
    familyTree: familyTreeDoc ? ({ id: familyTreeDoc.id, ...familyTreeDoc.data() } as PublishedFamilyTreeRecord) : null,
  };
}
